import { render, staticRenderFns } from "./DebugMenu.vue?vue&type=template&id=0524111c&scoped=true"
import script from "./DebugMenu.vue?vue&type=script&lang=js"
export * from "./DebugMenu.vue?vue&type=script&lang=js"
import style0 from "./DebugMenu.vue?vue&type=style&index=0&id=0524111c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524111c",
  null
  
)

export default component.exports